export default "__VITE_ASSET__Bh0e4iks__"